module.exports = __webpack_public_path__ + "img/static__image.a0fc58ce.png";